import { IServidor } from "@/interfaces/IServidor";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction("SERVIDOR/sync", (items: IServidor[]) => ({
  payload: { items },
}));

export const servidorAction = { sync };
